var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnapOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snap-off_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "snap-off_svg__\\u72B6\\u6001\\u680F\\u4E0D\\u540C\\u6837\\u5F0F",
    transform: "translate(-424.000000, -8.000000)",
    stroke: "#5A5A5A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "snap-off_svg__Snap-on",
    transform: "translate(410.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "snap-off_svg__\\u5220\\u9664",
    transform: "translate(14.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 21.6840146,
    id: "snap-off_svg__\\u8DEF\\u5F84-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "snap-off_svg__\\u8DEF\\u5F84-3",
    strokeLinejoin: "round",
    points: "2 6 8 11.8799096 2 19"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "snap-off_svg__\\u8DEF\\u5F84-3\\u5907\\u4EFD",
    strokeLinejoin: "round",
    transform: "translate(19.000000, 12.500000) scale(-1, 1) translate(-19.000000, -12.500000) ",
    points: "16 6 22 11.8799096 16 19"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapOff);
export default __webpack_public_path__ + "static/media/snap-off.695816ea.svg";
export { ForwardRef as ReactComponent };